import classnames from 'classnames/bind';
import { Skeleton } from '@mantine/core';

import { Thumbnail } from 'components/Thumbnail/Thumbnail';

import styles from './Files.module.scss';

const c = classnames.bind(styles);

export function FilesWidgetSkeleton() {
  return (
    <li>
      <div className={c('file')}>
        <Thumbnail isLoading />
        <div className={c('info')}>
          <Skeleton height="1rem" width="40%" />
          <Skeleton height="1rem" width="80%" />
          <Skeleton height="1rem" width="80%" />
        </div>
      </div>
    </li>
  );
}
